import { render } from "./CIS-Resource-PagedListing-Excerpt.vue?vue&type=template&id=6c56a80a&scoped=true"
import script from "./CIS-Resource-PagedListing-Excerpt.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-PagedListing-Excerpt.vue?vue&type=script&lang=js"

import "./CIS-Resource-PagedListing-Excerpt.vue?vue&type=style&index=0&id=6c56a80a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c56a80a"]])

export default __exports__